import { RegistrationModelSerialRequest } from '../../models/registration-model-serial/registration-model-serial-request.interface';

export const mockRegistrationModelSerialRequest: RegistrationModelSerialRequest =
  {
    uid: 'uid',
    modelNumber: 'DX1234',
    serialNumber: '123456789',
  };
